import React from "react";
import styles from "./Card.module.scss";

import Link from "next/link";
import If from "@/components/common/If";
import FormattedDate from "@/components/common/Date";
import RightArrow from "@/components/common/RightArrow";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ChevronDown } from "lucide-react";

/**
 *
 * Card
 *
 */
const Card = ({
  image,
  title,
  line2,
  line3,
  description,
  handle,
  isBlog = false,
  download = false,
  tags = [],
  type = "default",
  thumbnail = null,
  dropdownLinks = [],
  ...props
}) => {
  const appendParam = (url: string, param: string) => {
    if (!param) return url;
    const hasQuery = url.includes("?");
    const needsSeparator =
      hasQuery && !url.endsWith("?") && !url.endsWith("&") ? "&" : "";
    const separator = hasQuery ? needsSeparator : "?";
    return `${url}${separator}${param}`;
  };

  const normalizeSrc = (raw?: string) => {
    const cleaned = (raw || "/default-thumb.jpg")
      .replace("?format=pdf&", "?")
      .replace("format=pdf", "");
    const trimmed = cleaned.replace(/[?&]$/, "");
    if (trimmed.includes("bfldr.com") && !/[?&]width=\d+/i.test(trimmed)) {
      return appendParam(trimmed, "width=600");
    }
    return trimmed;
  };

  if (props.index === 0) {
    console.log(props.index, title);
  }
  // console.log(thumbnail?.url, handle);
  if (handle) {
    return (
      <Link
        href={handle.replace('?format=pdf&', '?').replace('format=pdf', '')}
        className="flex-resource"
        target={download && type !== "Website Page" ? "_blank" : "_self"}
      >
        <article
          className={`${styles.card} ${props.className} stack gap-6 max-h-max`}
        >
          <div
            className={`${styles.image} bg-light-gray ${isBlog ? "" : "p-4"}`}
          >
            <img
              className={`block aspect-[1/1] w-full object-contain max-w-full ${isBlog ? "w-full" : "w-[162px]"} mx-auto`}
              src={normalizeSrc(thumbnail?.url || image)}
              alt={title}
              width={300}
              height={300}
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className={styles.content}>
            {/* <If condition={tags?.length}>
              <div className="flex gap-2">
                {tags?.map((tag) => (
                  <span key={tag} className="text-sm text-gold">
                    {tag}
                  </span>
                ))}
              </div>
            </If> */}
            <h3 className={`${styles.title} leading-[1.55]`}>{title}</h3>
            <If condition={line2}>
              <p className={styles.description}>{line2}</p>
            </If>
            <If condition={line3}>
              <p className={styles.description}>{line3}</p>
            </If>
            <p className={styles.description}>{description}</p>
          </div>
          <If condition={dropdownLinks?.length > 0}>
            <div className="px-6 pb-6">
              <Select onValueChange={(value) => window.open(value, '_blank')}>
                <SelectTrigger className="bg-transparent border-current text-current focus:ring-0 focus:ring-offset-0 [&>svg]:hidden [&>svg]:hidden">
                  <SelectValue placeholder="Select an option..." />
                  <ChevronDown className="h-4 w-4 text-gold ml-auto ml-auto" />
                </SelectTrigger>
                <SelectContent>
                  {dropdownLinks.map((link, index) => (
                    <SelectItem key={index} value={link.value}>
                      {link.key}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </If>
        </article>
      </Link>
    );
  }
  return (
    <article
      className={`${styles.card} ${props.className} stack gap-6 max-h-max flex-resource`}
    >
      <div className={`${styles.image} bg-light-gray ${isBlog ? "" : "p-4"}`}>
        <img
          className={`max-w-full ${isBlog ? "w-full" : "w-[162px]"} mx-auto`}
          src={normalizeSrc(thumbnail?.url || image)}
          alt={title}
          width={300}
          height={300}
          loading="lazy"
          decoding="async"
        />
      </div>
      <div className={styles.content}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
      </div>
      <If condition={dropdownLinks?.length > 0}>
        <div className="px-6 pb-6">
          <Select onValueChange={(value) => window.open(value, '_blank')}>
            <SelectTrigger className="bg-transparent border-current text-current focus:ring-0 focus:ring-offset-0 [&>svg]:hidden">
              <SelectValue placeholder="Select an option..." />
              <ChevronDown className="h-4 w-4 text-gold ml-auto" />
            </SelectTrigger>
            <SelectContent>
              {dropdownLinks.map((link, index) => (
                <SelectItem key={index} value={link.value}>
                  {link.key}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </If>
    </article>
  );
};

export default Card;

export const BlogCard = ({
  image,
  title,
  subtitle,
  description,
  handle,
  date = "",
  isBlog = false,
  download = false,
  type = "default",
  thumbnail,
  dropdownLinks = [],
  isWhatsHappening = false,
  postType = '',
  ...props
}) => {
  console.log(type)
  const appendParam = (url: string, param: string) => {
    if (!param) return url;
    const hasQuery = url.includes("?");
    const needsSeparator =
      hasQuery && !url.endsWith("?") && !url.endsWith("&") ? "&" : "";
    const separator = hasQuery ? needsSeparator : "?";
    return `${url}${separator}${param}`;
  };

  const normalizeSrc = (raw?: string) => {
    const cleaned = (raw || "/default-thumb.jpg")
      .replace("?format=pdf&", "?")
      .replace("format=pdf", "");
    const trimmed = cleaned.replace(/[?&]$/, "");
    if (trimmed.includes("bfldr.com") && !/[?&]width=\d+/i.test(trimmed)) {
      return appendParam(trimmed, "width=600");
    }
    return trimmed;
  };

  console.log(image);
  if (handle) {
    return (
      <Link
        href={handle}
        className="flex-resource"
        target={download && type !== "Website Page" ? "_blank" : "_self"}
      >
        <article
          className={`${styles.card} ${props.className} stack gap-6 bg-[#EDEDED] h-full relative justify-between`}
        >
          <div
            className={`${styles.image} bg-light-gray ${isBlog ? "" : "p-4"}`}
          >
            <img
              className={`block aspect-[16/9] min-h-[250px] w-full max-w-full ${isBlog ? "w-full object-cover" : "w-[162px] object-contain"} mx-auto`}
              src={normalizeSrc(thumbnail?.url || image)}
              alt={title}
              width={300}
              height={300}
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className={`${styles.content} px-8 py-2 relative stack gap-6`}>
            {/* <FormattedDate date={date} className="text-gold text-sm" /> */}            
            <div className="flex flex-col gap-2">
              {postType && <p className="text-gold text-sm">{postType === "BlogPost" ? "Blog" : "Case Study"}</p>}
              <h3 className={`${styles.title} text-xl font-normal min-h-[2.65em]`}>
                {title.replace(/&amp;/g, "&") + (isWhatsHappening && !title.includes(':') ? `: ${subtitle}` : "")}
              </h3>
              <p className={`${styles.description} opacity-50`}>{description}</p>
            </div>
          </div>
          <div className="flex items-center gap-4 px-8 pb-8 text-dark-gray font-thin">
            <span className="currentColor">Read More</span>
            <RightArrow fill="currentColor" className="" />
          </div>
          <If condition={dropdownLinks?.length > 0}>
            <div className="px-8 pb-8">
              <Select onValueChange={(value) => window.open(value, '_blank')}>
                <SelectTrigger className="bg-transparent border-current text-current focus:ring-0 focus:ring-offset-0 [&>svg]:hidden">
                  <SelectValue placeholder="Select an option..." />
                  <ChevronDown className="h-4 w-4 text-gold ml-auto" />
                </SelectTrigger>
                <SelectContent>
                  {dropdownLinks.map((link, index) => (
                    <SelectItem key={index} value={link.value}>
                      {link.key}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </If>
        </article>
      </Link>
    );
  }
  return (
    <article
      className={`${styles.card} ${props.className} stack gap-6 max-h-max flex-resource`}
    >
      <div className={`${styles.image} bg-light-gray ${isBlog ? "" : "p-4"}`}>
        <img
          className={`block aspect-square w-full object-contain max-w-full ${isBlog ? "w-full" : "w-[162px]"} mx-auto`}
          src={normalizeSrc(image)}
          alt={title}
          width={300}
          height={300}
          loading="lazy"
          decoding="async"
        />
      </div>
      <div className={styles.content}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
      </div>
      <If condition={dropdownLinks?.length > 0}>
        <div className="px-6 pb-6">
          <Select onValueChange={(value) => window.open(value, '_blank')}>
            <SelectTrigger className="bg-transparent border-current text-current focus:ring-0 focus:ring-offset-0 [&>svg]:hidden">
              <SelectValue placeholder="Select an option..." />
              <ChevronDown className="h-4 w-4 text-gold ml-auto" />
            </SelectTrigger>
            <SelectContent>
              {dropdownLinks.map((link, index) => (
                <SelectItem key={index} value={link.value}>
                  {link.key}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </If>
    </article>
  );
};
